











import Component from 'vue-class-component'
import loading from '@/modules/common/components/loading.vue'
import page from '@/modules/common/components/page.vue'
// eslint-disable-next-line
import Pass from '@/modules/pass/domain/pass'
import passService from '@/modules/pass/domain/passService'
import passForm from '@/modules/pass/components/passForm.vue'
import Vue from 'vue'

@Component({
  components: { loading, page, passForm }
})
export default class HomePage extends Vue {
  pass: Pass | null = null

  get title () {
    return this.pass ? this.pass.name : ''
  }

  async created () {
    this.pass = await passService.getPass()
  }
}
